exports.AddToCart = (item_id, item_number, item_title, item_mrp, item_price, item_qty, item_img_url, item_url, max_qty) => {
    
    var carts = localStorage.getItem('carts')?JSON.parse(localStorage.getItem('carts')): [];
    
    if (carts !== "" && carts !== undefined && carts !== null) {
        // carts = JSON.parse(carts);
        const index = carts.findIndex(item => item.item_number === item_number);
        if (index !== -1) {
            var remaining = Number(carts[index].max_qty) - carts[index].item_qty;
            if(item_qty > remaining ){
                carts[index].item_qty = carts[index].max_qty;
            }else{
                carts[index].item_qty = carts[index].item_qty + item_qty;
            }
           
            localStorage.setItem('carts', JSON.stringify(carts));
            return true;
        }else{
            carts.push({item_id: item_id, item_number: item_number, item_title: item_title, item_mrp: item_mrp, item_price: item_price, item_qty: item_qty, item_img_url: item_img_url, item_url: item_url, max_qty: max_qty});
            localStorage.setItem('carts', JSON.stringify(carts));
            return true;
        }
    }else{
        carts.push({item_id: item_id, item_number: item_number, item_title: item_title, item_mrp: item_mrp, item_price: item_price, item_qty: item_qty, item_img_url: item_img_url, item_url: item_url, max_qty: max_qty});
        localStorage.setItem('carts', JSON.stringify(carts));
        return true;
    }
    
}

exports.GetCartItemQty = async(item_number) =>{
    var carts = localStorage.getItem('carts')?JSON.parse(localStorage.getItem('carts')): [];
    
    if (carts !== "" && carts !== undefined && carts !== null) {
        const index = carts.findIndex(item => item.item_number === item_number);
        if (index !== -1) {
            return Number(carts[index].item_qty);
        }else{
            return 0;
        }
    }else{
        return 0;
    }
}
exports.DeleteCartItem = (index) => {
    
    var carts = localStorage.getItem('carts');
    console.log("carts",carts);
    carts = JSON.parse(carts);
    carts.splice(index, 1);
    localStorage.setItem('carts', JSON.stringify(carts));
   
    return true;
}

exports.QtyUpdate = (index, qty) => {
    var carts = localStorage.getItem('carts');
    carts = JSON.parse(carts);
    
    carts[index].item_qty = qty;
    localStorage.setItem('carts', JSON.stringify(carts));
    return true;
}

exports.GetCarts = () => {
    var carts = localStorage.getItem('carts');
    
    if(carts === "" || carts === null){
      return [];
    }
    
    carts = carts!==""?JSON.parse(carts):[];
    // console.log("carts", carts)
    return carts;
}

exports.ClearCart = () => {
    localStorage.setItem('carts', '');
    localStorage.setItem("coupon", "");
}